import axios from "axios";

type MortgageVariant = "local" | "alpha_mortgage" | "delta_mortgage";
const isLocalHost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

const variant: MortgageVariant =
  (process.env.REACT_APP_MORTGAGE_VARIANT as MortgageVariant | undefined) ??
  (isLocalHost ? "local" : "delta_mortgage");

const BACKEND_URLS: Record<MortgageVariant, string> = {
  local: "http://localhost:4002/api/",
  alpha_mortgage: "https://alpham-backend.vercel.app/api/",
  // Production API (Vercel)
  delta_mortgage: "https://alpham-backend.vercel.app/api/",
};

const WORDPRESS_URLS: Record<MortgageVariant, string> = {
  local: "https://alpham.ca/",
  alpha_mortgage: "https://alpham.ca/",
  delta_mortgage: "https://alpham.ca/",
};

const ASSETS_URLS: Record<MortgageVariant, string> = {
  local: "http://localhost:4002/uploads/",
  alpha_mortgage: "https://alpham-backend.vercel.app/uploads/",
  delta_mortgage: "https://mortgageimage.s3.eu-west-2.amazonaws.com/",
};

// Allow direct overrides if set (still supports variant switching).
export const WORDPRESS_URL =
  process.env.REACT_APP_WORDPRESS_URL || WORDPRESS_URLS[variant];
export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || BACKEND_URLS[variant];
export const ASSETS_URL = process.env.REACT_APP_ASSETS_URL || ASSETS_URLS[variant];


export default axios;
